import React from "react";
import { fmtNumber } from "../shared/format";

// DrainLoss — the loss stated in the gap between two drain rows (V6 §F.3: "between
// each pair of rows, the loss is stated in the gap where it happens, using
// dropped_here and drop_label verbatim").
//
// THE LARGEST LOSS TAKES THE LEAKING TREATMENT AT GREATER WEIGHT (§F.4, C.2). Which
// one that is comes from the backend's `is_largest_drop`, never from hardcoding a
// stage — TheDrain resolves it and passes `leaking` here. Every other loss renders
// muted: present, but not the signal.
//
// The label is the backend's own fragment (drop_label). Never one we write: a loss
// with no label renders the number alone rather than a sentence we invented.
const DrainLoss = ({ dropped, label, leaking = false }) => (
  <div
    data-testid="drain-loss"
    data-leaking={leaking ? "true" : "false"}
    className="flex items-baseline gap-2 pl-2 py-1"
  >
    <span
      className={`tabular-nums shrink-0 ${
        leaking
          ? "gi-body font-semibold text-red-600 dark:text-red-400"
          : "gi-label text-gray-500 dark:text-gray-400"
      }`}
    >
      −{fmtNumber(dropped)}
    </span>
    {label && (
      <span
        className={
          leaking
            ? "gi-body text-gray-800 dark:text-gray-100"
            : "gi-body text-gray-600 dark:text-gray-400"
        }
      >
        {label}
      </span>
    )}
  </div>
);

export default DrainLoss;
